module.exports = require("escodegen");